import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const services = [
  {
    key: "crudeOil",
    icon: "ri-oil-line",
    img: "https://public.readdy.ai/ai/img_res/4a21d73d1f51e140698ab5ae75f4bc6f.jpg",
  },
  {
    key: "lng",
    icon: "ri-fire-line",
    img: "https://readdy.ai/api/search-image?query=LNG%20liquefied%20natural%20gas%20terminal%20with%20large%20storage%20tanks%20and%20loading%20infrastructure%2C%20industrial%20energy%20facility%2C%20clean%20professional%20photography&width=600&height=400&seq=svc002&orientation=landscape",
  },
  {
    key: "market",
    icon: "ri-line-chart-line",
    img: "https://readdy.ai/api/search-image?query=energy%20market%20data%20analysis%20dashboard%20with%20charts%20and%20graphs%2C%20financial%20trading%20screens%2C%20professional%20business%20analytics%2C%20clean%20modern%20office%20setting&width=600&height=400&seq=svc003&orientation=landscape",
  },
  {
    key: "contract",
    icon: "ri-file-text-line",
    img: "https://readdy.ai/api/search-image?query=professional%20business%20contract%20negotiation%20meeting%2C%20executives%20at%20conference%20table%2C%20formal%20business%20setting%2C%20clean%20modern%20office%2C%20natural%20lighting&width=600&height=400&seq=svc004&orientation=landscape",
  },
];

export default function ServicesPreview() {
  const { t } = useTranslation(["pages"]);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-emerald-700 text-sm font-semibold uppercase tracking-widest mb-3">
              {t("pages:home.services.sectionTitle")}
            </p>
            <h2
              className="text-4xl md:text-5xl font-bold leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              <span className="italic text-emerald-700">
                {t("pages:home.services.title")}
              </span>
              <br />
              <span className="text-slate-900">
                {t("pages:home.services.titleHighlight")}
              </span>
            </h2>
          </div>
          <p className="text-slate-500 text-base max-w-md leading-relaxed">
            {t("pages:home.services.description")}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((svc) => (
            <div
              key={svc.key}
              className="group rounded-xl overflow-hidden border border-gray-100 hover:border-emerald-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={svc.img}
                  alt={t(`pages:home.services.items.${svc.key}.title`)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-emerald-50 text-emerald-700 mb-3">
                  <i className={`${svc.icon} text-lg`} />
                </div>
                <h3 className="text-base font-bold text-slate-900 mb-2">
                  {t(`pages:home.services.items.${svc.key}.title`)}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed">
                  {t(`pages:home.services.items.${svc.key}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 border border-emerald-700 text-emerald-700 hover:bg-emerald-700 hover:text-white font-semibold px-8 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            {t("pages:home.services.cta")}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}